export const locales = {
    'en-NG': { rtl: false },
    'en-EG': { rtl: false },
    'en-SN': { rtl: false },
    'en-CI': { rtl: false },
    'ar-EG': { rtl: true },
    'fr-SN': { rtl: false },
    'fr-CI': { rtl: false }
};
